import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';
import { environment } from '@/environments/environment';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
	private readonly KEY = 'team-peps-cookie-consent';
	private readonly isBrowser: boolean;
	private loaded = false;

	constructor(@Inject(PLATFORM_ID) platformId: object) {
		this.isBrowser = isPlatformBrowser(platformId);
	}

	get hasConsent(): boolean | null {
		if (!this.isBrowser) return null;
		const v = localStorage.getItem(this.KEY);
		if (v === 'granted') return true;
		if (v === 'denied')  return false;
		return null;
	}

	init(): void {
		if (this.hasConsent === true) this.loadGA();
	}

	grant(): void {
		if (!this.isBrowser) return;
		localStorage.setItem(this.KEY, 'granted');
		this.loadGA();
	}

	deny(): void {
		if (!this.isBrowser) return;
		localStorage.setItem(this.KEY, 'denied');
	}

	trackPage(url: string): void {
		if (!this.loaded) return;
		(window as any).gtag('event', 'page_view', { page_path: url });
	}

	private loadGA(): void {
		if (!this.isBrowser || this.loaded || !environment.gaId) return;
		this.loaded = true;
		(window as any).dataLayer = (window as any).dataLayer || [];
		(window as any).gtag = function() { (window as any).dataLayer.push(arguments); };
		(window as any).gtag('js', new Date());
		(window as any).gtag('config', environment.gaId, { send_page_view: false });
		const script = document.createElement('script');
		script.async = true;
		script.src = `https://www.googletagmanager.com/gtag/js?id=${environment.gaId}`;
		document.head.appendChild(script);
	}
}
